import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface IButtonNetwork {
  icon: IconProp;
  link: string;
}

export const ButtonNetwork: React.FC<IButtonNetwork> = ({
  icon,
  link,
}) => {
  return (
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center space-x-2 hover:text-red-600"
      >
        <FontAwesomeIcon icon={icon} className='size-5' />
      </a>
  );
};
